import CountryFlag from "react-country-flag";
import { GroupBase, OptionProps, components } from "react-select";

import { Flex } from "@chakra-ui/react";

import { SelectOptionInterface } from "@ts/interfaces/UI/UiInterface";

import { Text } from "@components/Text";

const CountryOption = (
    props: OptionProps<
        SelectOptionInterface,
        false,
        GroupBase<SelectOptionInterface>
    >
) => {
    const {
        data: { value: countryCode, label: countryName }
    } = props;

    return (
        <components.Option {...props}>
            <Flex gap={2} align="center">
                <CountryFlag
                    countryCode={countryCode}
                    svg
                    style={{ width: 20, height: "auto" }}
                />
                <Text>{countryName}</Text>
            </Flex>
        </components.Option>
    );
};

export default CountryOption;
